import { log } from 'lib/observability';
import { AnalyticsEventKey, logAnalyticsEvent } from 'modules/analytics/logAnalyticsEvent';
import { checkoutActions } from 'modules/checkout/checkoutStore';
import { useSubscriptionStore } from 'modules/subscription/stores/subscriptionStore';

import { formatUpsellModalTypeAsString } from '../../utils';
import { UpsellModalType } from '../types';
import { useUpsellStore } from '../upsellStores';

export const showUpsellModal = async (modal: UpsellModalType) => {
  // Debug log to help with debugging this issue: https://linear.app/speechify-inc/issue/WEB-7585/intermittent-pop-up-for-premium-users-on-login
  try {
    log(['showUpsellModal'], {
      context: {
        source: 'showUpsellModal',
        modal,
        stack: JSON.stringify(new Error('').stack),
        subscriptionStoreState: JSON.stringify(useSubscriptionStore.getState())
      }
    });
  } catch (e) {
    // No need to handle, we just don't want this code to affect the user experience if it fails for some reason
  }

  checkoutActions.loadCheckoutToken();
  useUpsellStore.setState({ activeModal: modal });
  logAnalyticsEvent(AnalyticsEventKey.upsellModalsContextual, { variant: formatUpsellModalTypeAsString(modal)! });
};
